import type {
  CubeBriefInfo,
  DomainType,
  ObjectTreeNode,
  ObjectTypes,
  SeismicAttributeInfoType,
  SelectItem,
  Survey2dInfo,
} from '@core/core/types'
import type { Nullable, WellId } from 'common/types'

import type { SurveyType } from '../types'
import type { CoordinateName, CoordinateSelectionOption } from './constants'

export type AddingFilesModalContainerPropsType = {
  files: File[]
  treeObject: Nullable<ObjectTreeNode>
  mode?: AddingFilesModes
}

export type OnSaveFormData = FormDataType | FormDataAttributeType | FormDataVSPType

type AddingFilesModalPropsBaseType = {
  fileName: string
  objectName?: string
  initialSurveyGroup?: SurveyGroupType
  isViewObjectName?: boolean
  isModalOpen: boolean

  onCancel: () => void
  onSave: (formData?: OnSaveFormData) => void
}

export type AddingFilesModalPropsType = AddingFilesModalPropsBaseType & {
  survey2DItems?: Survey2dInfo[]
  survey3DItems?: CubeBriefInfo[]
  domainItems: DomainType[]
  isOneFileDownload: boolean
  isViewDomains?: boolean
  isViewAxisZDirection?: boolean
  treeObject?: Nullable<ObjectTreeNode>
  uploadingType?: ObjectTypes
  onSaveForAll: (formData: FormDataType) => void
}

export type AddingFilesAttributeModalPropsType = AddingFilesModalPropsBaseType & {
  attributeItems: SeismicAttributeInfoType[]
}

export type AddingFilesVSPModalPropsType = AddingFilesModalPropsBaseType & {
  wellItems: SelectItem[]
}

type FormDataBaseType = {
  objectName?: AddingFilesModalPropsBaseType['objectName']
  isNegativeZ?: boolean
  isNegativeTwt?: boolean
}

export type FormDataVSPType = FormDataBaseType & {
  wellId?: WellId
}

export type AddingFilesModalHeaderPropsType = Pick<AddingFilesModalPropsBaseType, 'fileName'>

export type AddingFilesModalFooterPropsType = {
  isViewSaveAllBtn: boolean
  isDisabledOnSaveBtn: boolean
  onCancel: () => void
  onSave: () => void
  onSaveForAll?: () => void
}

export type FormDataType = {
  objectName?: AddingFilesModalPropsType['objectName']
  survey2D?: Survey2dInfo
  survey3D?: CubeBriefInfo
  coordinateSelectionRule?: CoordinateSelectionOption
  coordsTemplates?: CoordsTemplate
  domain?: DomainType
  areZValuesNegative?: boolean
}

export type CoordsTemplate = { xOffset?: number; yOffset?: number }

export type CoordinatesType = {
  name: CoordinateName
  values: { label: string }[]
  coordName: keyof CoordsTemplate
}

export type FormDataAttributeType = {
  attribute?: SeismicAttributeInfoType
  newAttributeObjectName?: string
} & Partial<Pick<FormDataType, 'objectName'>>

export type UseAddingFilesTypeReturn = {
  activeFileReady?: File
  visibleModal: boolean
  isOneFileDownloaded: boolean
  onCancel: AddingFilesModalPropsType['onCancel']
  onSave: AddingFilesModalPropsType['onSave']
  onSaveForAll: AddingFilesModalPropsType['onSaveForAll']
}

export enum AddingFilesModes {
  Nx1 = 'Nx1', // 1 horizon from N files mode
  NxN = 'NxN', // N horizon from N files mode
}

export type SurveyGroupType = SurveyType.TwoD | SurveyType.ThreeD

export type FilesUploadType = {
  file: File
  formData: FormDataType
  horizonId?: string
}
